"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyProjectPermissions = exports.fetchUser = exports.fetchProjects = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
const ActionTypes = require("../../actionTypes/user/projects");
const Actions = require("../../actions/user/projects");
function fetchProjects(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_PROJECTS_REQUEST), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/user/projects?user=${action.payload.id}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .array(t.interface({
            user: t.union([sok_types_1.User.iAuthor, sok_types_1.User.iFirstTimeUser]),
            project: sok_types_1.Project.iProject,
            groups: t.array(sok_types_1.UserGroup.iUserGroup)
        }))
            .decode(response);
        const act = validation.fold((l) => Actions.fetchProjectsFailed((0, errorHandling_1.parseValidationError)(l)), (x) => Actions.fetchProjectSuccess(x));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchProjectsFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.fetchProjects = fetchProjects;
function fetchUser(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_USER_REQUEST), (0, operators_1.switchMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/admin/user?search=${encodeURIComponent(action.payload.email)}`
    }).pipe((0, operators_1.mergeMap)((res) => {
        const validation = t.array(sok_types_1.User.iUser).decode(res.response.users);
        const act = validation.fold((l) => Actions.fetchUserFailed((0, errorHandling_1.parseValidationError)(l)), (users) => Actions.fetchUserSuccess(users));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchUserFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.fetchUser = fetchUser;
function copyProjectPermissions(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.COPY_PROJECT_PERMISSIONS), (0, operators_1.switchMap)((action) => {
        const userProjects = store.value.user.projects;
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: {
                copyFrom: userProjects.user ? userProjects.user.uuid : null,
                copyTo: userProjects.selectedUsers.map((u) => u.uuid),
                projects: userProjects.selectedProjects
            },
            url: `${baseUrl}api/admin/user/copy-permissions`
        }).pipe((0, operators_1.mergeMap)((response) => {
            if (response.status === 200) {
                return (0, rxjs_1.of)(Actions.copyProjectPermissionsSuccess());
            }
            return (0, rxjs_1.of)(Actions.copyProjectPermissionsFailure((0, errorHandling_1.parseAjaxErrorResponse)(response.response)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchUserFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.copyProjectPermissions = copyProjectPermissions;
//# sourceMappingURL=projects.js.map